<template>
  <div>
    <CustomAlert title="">
      <button
        v-if="!isProcessing"
        class="btn btn-primary w-100 m-1 fw-bold"
        type="submit"
        @click.prevent="onSave()"
      >
        Save
      </button>
      <button
        v-else
        class="btn btn-primary w-100 m-1 fw-bold disabled"
        disabled
      >
        Saving...
      </button>
    </CustomAlert>
  </div>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";
import DatastoreAPI from "@/helpers/DatastoreAPI";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "SaveButton",
  mixins: [DatastoreAPI],
  components: {
    CustomAlert
  },
  data() {
    return {
      isProcessing: false
    };
  },
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["mapToDatastore"])
  },
  methods: {
    ...mapActions(["setForm"]),
    onSave() {
      this.isProcessing = true;
      this.setForm(this.formData);
      this.updateEntry(this.mapToDatastore, () => {
        this.$emit("onSaveEvent");
        this.isProcessing = false;
      });
    }
  }
};
</script>
